export const TEST_ID = 'selectPartField';
